import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";
import { Certificate } from "types";
import type { RootState } from "../store";

// Define a type for the slice state
interface AddCertificateState {
  certificate: Certificate;
}

// Define the initial state using that type
const initialState: AddCertificateState = {
  certificate: null,
};

export const addCertificateSlice = createSlice({
  name: "addCertificate",
  // `createSlice` will infer the state type from the `initialState` argument
  initialState,
  reducers: {
    // Use the PayloadAction type to declare the contents of `action.payload`
    setCertificate: (state, action: PayloadAction<Certificate>) => {
      state.certificate = action.payload;
    },
  },
});

export const { setCertificate } = addCertificateSlice.actions;

// Other code such as selectors can use the imported `RootState` type
export const selectAddCertificateData = (state: RootState) =>
  state.addCertificate.certificate;
export default addCertificateSlice.reducer;
